export default __webpack_public_path__ + "media/Empathy.985ed180.svg";